

















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Popup, Collapse, CollapseItem } from "vant";
Vue.use(Popup).use(Collapse).use(CollapseItem);
@Component({
  components: {},
})
export default class Home extends Vue {
  public downloadShow = false;
  public downShow = false;
  public nowLink = "/index";
  @Prop({ type: Array, default: [] }) public linkList;

  @Watch("$route")
  public change() {
    this.linkList.forEach((item) => {
      if (item.path == this.$route.path) {
        this.nowLink = item.path;
      }
    });
  }
  public show() {
    this.downloadShow = true;
  }
  public topClose() {
    const tops = "";
  }
  public centerClose() {
    const centers = "";
  }
  public closeModel() {
    this.downloadShow = false;
  }
  public getPaths(item) {
    if (item.path == "7") {
      return
    } else if (item.name == "传奇论坛") {
      window.open("http://bbs.996m2.com/", "_blank");
      return false;
    } else if (item.name == "传世论坛") {
      window.open("http://woool.996m2.com/", "_blank");
      return false;
    } else if (item.name == "传奇3论坛") {
      window.open("https://mir3.996m2.com/m/", "_blank");
      return false;
    } else {
      this.downloadShow = false;
      this.$emit("getPath", item);
    }
  }
  public unfoldList() {
    this.downShow = !this.downShow
  }
}
